import React from "react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer-container">
      <span>&copy; {year} Contents Works inc.</span>
    </footer>
  );
};